export enum AudioType {
    VOTING_STARTED = "VOTING_STARTED",
    VOTING_REMINDER = "VOTING_REMINDER"
}